<via-loading-spinner *ngIf="isPageLoading"></via-loading-spinner>
<div class="e-sku-metadata-container" role="main" *ngIf="capsuleItem">
    <div class="e-left-content">
        <div class="e-sku-image">
            <img
                [id]="capsuleItem?.emiItemId"
                *ngIf="capsuleItem?.emiImageUrl !== ''; else placeholderImage"
                [src]="blobStorageUrl + capsuleItem?.emiImageUrl + imageSasParams"
                alt="SKU product image"
                (error)="handleMissingImage(capsuleItem.emiItemId)" />
            <ng-template #placeholderImage>
                <img [src]="noImagePlaceholderUrl" class="e-placeholder-image" alt="SKU product image not found" />
            </ng-template>
        </div>
        <div class="e-scorecards-container" role="region" aria-label="SKU scorecard">
            <div class="e-spinner" *ngIf="isLoading">
                <mat-spinner [diameter]="20"></mat-spinner>
            </div>
            <div class="e-error-message" *ngIf="errorResponse && !isLoading">
                {{ errorResponse }}
            </div>
            <div class="e-scorecard">
                <via-scorecard *ngFor="let scorecardItem of scorecardItems"
                    [title]="scorecardItem.title" [value]="scorecardItem.value" [iconClass]="scorecardItem.iconClass">
                </via-scorecard>
            </div>
        </div>
    </div>

    <div class="e-sku-metadata" role="region" aria-label="SKU metadata">
        <h1 class="e-sku-name" [title]="capsuleItem.name">
            <!--TODO: Phase 2
                 <via-feedback-flag [feedbackReviewPending]="skuMetadata.feedbackReviewPending"
                (submitFeedback)="onSubmitFeedback($event)">
            </via-feedback-flag> -->
            {{ capsuleItem.name }}
        </h1>
        <div class="e-sku-metadata-table">
            <div class="e-sku-metadata-row">
                <div class="e-sku-metadata-column">
                    <dl>
                        <dt>EMIItemId:</dt>
                        <dd>{{ capsuleItem?.emiItemId }}</dd>
                        <dt>Country:</dt>
                        <dd>{{ capsuleItem.country?.name }}</dd>
                        <dt>Via Industry:</dt>
                        <dd>{{ capsuleItem.industry?.name }}</dd>
                        <ng-container *ngIf="getLevelOneCategoryDetails()">
                            <dt>Via Category:</dt>
                            <dd>{{ getLevelOneCategoryDetails()?.name }}</dd>
                        </ng-container>
                        <ng-container *ngIf="getSubCategory()">
                            <dt>Via Subcategory:</dt>
                            <dd>{{ getSubCategory()?.name }}</dd>
                        </ng-container>
                        <ng-container *ngIf="capsuleItem?.supplier">
                            <dt>Supplier:</dt>
                            <dd>{{ capsuleItem.supplier?.name }}</dd>
                        </ng-container>
                        <dt>Brand:</dt>
                        <dd>{{ capsuleItem.brand?.name }}</dd>
                        <ng-container *ngIf="capsuleItem.brand?.subBrandId">
                            <dt>Sub-brand:</dt>
                            <dd>{{ capsuleItem.brand?.subBrandName }}</dd>
                        </ng-container>
                        <dt>Retailer(s):</dt>
                        <dd>
                            <ng-container *ngFor="let retailer of capsuleItem?.retailers">
                                <a [href]="retailer.siteLink" target="_blank">{{ retailer?.name }}</a><br>
                            </ng-container>
                        </dd>
                    </dl>
                    <dl>
                        <ng-container *ngFor="let measure of capsuleItem?.measures">
                            <dt *ngIf="measure.measure !== 0 && measure?.measureName">
                                {{ getDisplayMeasureName(measure) }}:
                            </dt>
                            <dd *ngIf="measure.measure !== 0">{{ measure?.measure }} {{ getMeasureUnitName(measure) }}
                            </dd>
                        </ng-container>
                    </dl>
                </div>
                <div class="e-sku-metadata-column">
                    <dl>
                        <ng-container *ngFor="let attribute of capsuleAttributesGroup | keyvalue">
                            <dt>{{ attribute.key }}:</dt>
                            <dd>{{ attribute.value }}</dd>
                        </ng-container>
                    </dl>
                    <!--TODO: Hidden for MVP release
                    <div class="e-sku-metadata-column" *ngIf="capsuleItem?.ingredients">
                        <dl>
                            <dt>Ingredients:</dt>
                            <dd>{{capsuleItem?.ingredients}}</dd>
                        </dl>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</div>